import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DialogCleanupService {

  destroyAllDialogs() {
    if (typeof $ !== 'undefined') {
      $('.ui-dialog-content').each(function () {
        try {
          ($(this) as any).dialog('destroy').hide();
        } catch (e) {}
      });

      $('.ui-dialog').remove();      // remove wrapper
      $('.ui-widget-overlay').remove(); // remove overlay
    }
  }
}